import "../nature/NaturePage.scss";
import NatureVideo from "../../assets/nature/nature_17.mp4";
import Nav from "../../components/navbar/Nav";
import nature from "../../assets/nature/naturepage_mobile.png";

export default function NaturePage() {
  const text = [
    {
      text: "mother",
    },
    {
      text: "change",
    },
    {
      text: "boundless",
    },
    {
      text: "anonymous",
    },
    {
      text: "frugal",
    },
    {
      text: "not one",
    },
    {
      text: "honest",
    },
    {
      text: "specialisation",
    },
    {
      text: "sacred",
    },
  ];

  return (
    <section className="nature-page">
      <Nav isNavSticky={true} />
      <div className="d-none d-md-block d-lg-block">
        <video class="bg-video" autoPlay loop muted playsInline preload="auto">
          <source src={NatureVideo} type="video/mp4" />
        </video>
      </div>
      <div className="d-md-none d-lg-none">
        <div class="section img-section">
          <img src={nature} alt="" />
        </div>
        {text.map((item, index) => (
          <div class="section text-section">
            <p key={index}>
              is
              <br />
              {item?.text}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
